import { useCollection } from '@nandorojo/swr-firestore';
import React from 'react';
import { ISimejiItem } from './simejiStatus.interface';
import { RootPath } from '@routes/routePath';
import SimejiBody from './SimejiBody/SimejiBody';
import { masterSet } from '@masterSetting/masterSet/masterSetting';

function Simeji() {
  const collectionPath = RootPath.Simeji;
  const { data } = useCollection<ISimejiItem>(collectionPath, {
    listen: true,
    where: ['isShow', '==', true],
  });

  if (!masterSet.simeji) return null;

  const list = data
    ? data.map((item, i) => {
      return <SimejiBody data={item} key={i} />;
    })
    : null;
  return <>{list}</>;
}

export default Simeji;
